import { createTheme, Theme } from "@mui/material/styles";

const lightTheme: Theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#2563EB", light: "#60A5FA", dark: "#1D4ED8" },
    secondary: { main: "#0F766E", light: "#2DD4BF", dark: "#115E59" },
    background: {
      default: "#F8FAFC",
      paper: "#FFFFFF",
    },
  },

  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontSize: "2.5rem", fontWeight: 700 },
    h2: { fontSize: "2rem", fontWeight: 700 },
    h3: { fontSize: "1.75rem", fontWeight: 700 },
    h4: { fontSize: "1.5rem", fontWeight: 700 },
    h5: { fontSize: "1.25rem", fontWeight: 700 },
    h6: { fontSize: "1rem", fontWeight: 700 },
    allVariants: { color: "#0F172A" },
  },

  shape: { borderRadius: 12 },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 700,
          borderRadius: 8,
          minHeight: 38,
          paddingInline: 16,
          textTransform: "none",
          boxShadow: "0 10px 22px rgba(37,99,235,0.14)",
          transition: "all .22s ease",
          "&:hover": {
            boxShadow: "0 14px 28px rgba(37,99,235,0.20)",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: "1px solid #E2E8F0",
          boxShadow: "0 6px 20px rgba(15,23,42,0.05)",
          backgroundImage: "none",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: "rgba(255,255,255,0.70)",
          backdropFilter: "blur(20px)",
          border: "1px solid #E2E8F0",
          transition: "all .25s ease",
          "&:hover": {
            boxShadow: "0 16px 34px rgba(15,23,42,0.10)",
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: { size: "small" },
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": { borderRadius: 8, minHeight: 42 },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 16,
          border: "1px solid #E2E8F0",
          boxShadow: "0 24px 64px rgba(15,23,42,.20)",
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: { root: { fontWeight: 800, padding: "20px 24px 12px" } },
    },
    MuiDialogActions: {
      styleOverrides: { root: { padding: "16px 24px 20px" } },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 6, fontWeight: 800, fontSize: "0.72rem", height: 26 },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: { height: 3, borderRadius: "3px 3px 0 0" },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          width: 240,
          background: "linear-gradient(180deg,#FFFFFF 0%,#F8FAFC 100%)",
          borderRight: "1px solid #E2E8F0",
          boxShadow: "10px 0 30px rgba(15,23,42,0.08)",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          margin: "4px 8px",
          transition: "all .22s ease",
          color: "#334155",
          "&:hover": {
            background: "rgba(37,99,235,.07)",
          },
          "&.Mui-selected": {
            background: "rgba(37,99,235,.13)",
            color: "#2563EB",
            fontWeight: 800,
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: "rgba(37,99,235,.78)",
          ".Mui-selected &": { color: "#2563EB" },
        },
      },
    },
  },
});

export default lightTheme;
